import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Seo from "@/components/Seo";
import HeroSection from "@/components/landing/HeroSection";

// Defer below-the-fold sections to shrink the initial JS bundle.
const ProblemSection = lazy(() => import("@/components/landing/ProblemSection"));
const ProductHeroSection = lazy(() => import("@/components/landing/ProductHeroSection"));
const HowItWorksSection = lazy(() => import("@/components/landing/HowItWorksSection"));
const BenefitsSection = lazy(() => import("@/components/landing/BenefitsSection"));
const MakerStorySection = lazy(() => import("@/components/landing/MakerStorySection"));
const TrustHygieneSection = lazy(() => import("@/components/landing/TrustHygieneSection"));
const SocialProofSection = lazy(() => import("@/components/landing/SocialProofSection"));
const FinalCTASection = lazy(() => import("@/components/landing/FinalCTASection"));
const Footer = lazy(() => import("@/components/Footer"));
const VideoDemoSection = lazy(() => import("@/components/landing/VideoDemoSection"));
const RitualVideoSection = lazy(() => import("@/components/landing/RitualVideoSection"));

const Index = () => (
  <>
    <Seo
      title="Oli — the kitchen sink strainer, reconsidered"
      description="Oli is a beautifully simple sink strainer that gives every meal a quieter, cleaner ending. Made for everyday kitchens."
      path="/"
    />
    <Header />
    <main>
      <HeroSection />
      <Suspense fallback={null}>
        <VideoDemoSection />
        <ProblemSection />
        <ProductHeroSection />
        <HowItWorksSection />
        <BenefitsSection />
        <MakerStorySection />
        <TrustHygieneSection />
        <SocialProofSection />
        <RitualVideoSection />
        <FinalCTASection />
      </Suspense>
    </main>
    <Suspense fallback={null}>
      <Footer />
    </Suspense>
  </>
);

export default Index;
